import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, BaasicButton, BaasicDropdown, BaasicModal, BasicInput, BaasicDraggableModal } from "core/components";
import { observer } from "mobx-react";
import { FacilityOrderTemplateItemNewFlowCalculationModal, FacilityOrderTemplateItemNewFlowNoteModal } from "application/facility-order-new-flow/components";

const FacilityOrderTemplateNewFlowCreateTemplate = function ({ facilityOrderTemplateNewFlowCreateViewStore, disabled }) {
    const {
        form,
        subCategoryStore,
        facilityOrderTemplateItems,
        facilityOrderTemplateTrachItems,
        facilityOrderTemplateItemNewFlowCalculationModal,
        facilityOrderTemplateItemNewFlowNoteModal,
        disabledTable
    } = facilityOrderTemplateNewFlowCreateViewStore;

    return (
        <React.Fragment>
            <div className="row">
                <div className="form__group col col-med-3">
                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} disabled={disabled || disabledTable}/>
                </div>
                <div className="form__group col col-med-9">
                    <BasicInput field={form.$('portalNote')} disabled={disabled || disabledTable}/>
                </div>
            </div>
            <div className="table--tertiary__wrapper u-mar--bottom--sml">
                <TemplateItemsTable facilityOrderTemplateNewFlowCreateViewStore={facilityOrderTemplateNewFlowCreateViewStore} facilityOrderTemplateItems={facilityOrderTemplateItems} disabled={disabled}/>
            </div>
            {facilityOrderTemplateTrachItems.length > 0 &&
                <div className="table--tertiary__wrapper">
                    <TemplateItemsTable facilityOrderTemplateNewFlowCreateViewStore={facilityOrderTemplateNewFlowCreateViewStore} facilityOrderTemplateItems={facilityOrderTemplateTrachItems} disabled={disabled}/>
                </div>
            }
            <BaasicDraggableModal modalParams={facilityOrderTemplateItemNewFlowCalculationModal} className="modal__content modal--lrg">
                <FacilityOrderTemplateItemNewFlowCalculationModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderTemplateItemNewFlowNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateItemNewFlowNoteModal />
            </BaasicModal>
        </React.Fragment>
    );
};

const TemplateItemsTable = observer(({ facilityOrderTemplateNewFlowCreateViewStore, facilityOrderTemplateItems, disabled }) => {
    const {
        facilityOrderTemplateTrachItems,
        productStore,
        itemCategory,
        saveItem,
        editItem,
        deleteItem,
        openFacilityOrderTemplateItemNewFlowCalculationModal,
        isMasterPatient,
        disabledTable
    } = facilityOrderTemplateNewFlowCreateViewStore;

    const productDropdownItemRender = (li, itemProps) => {
        const itemName = itemProps && itemProps.dataItem.description;
        const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && itemCategory === "ostomy" ?
            <i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
        const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
        const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
        const itemChildren = (
            <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <span style={{ flex: "1" }}> {li.props.children} </span>
                <span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    const isEnteral = itemCategory === "enteral" && facilityOrderTemplateItems !== facilityOrderTemplateTrachItems;

    return (
        <table className="table table--tertiary">
            <colgroup>
                <col width="225" />
                <col width="200" />
                <col width="90" />
                <col width="70" />
                <col width="200" />
                <col width="70" />
            </colgroup>
            <thead>
                <tr>
                    <th>Item Id</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>{isMasterPatient ? "SO QTY" : "QTY"}</th>
                    <th>NOTE</th>
                    <th className="type--right">Actions</th>
                </tr>
            </thead>
            <tbody>
                {facilityOrderTemplateItems.map((item, index) => {
                    var isFormula = (item && item.product && item.product.itemType && (item.product.itemType.abrv === 'bottle' || item.product.itemType.abrv === 'can')) || (item.product && item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155");
                    return (
                        <tr key={item.id}>
                            <td>
                                {
                                    item.product ? item.product.itemId :
                                        <BaasicDropdown
                                            placeholder="Select an ID..."
                                            store={productStore}
                                            value={item.product}
                                            itemRender={productDropdownItemRender}
                                            onChange={(e) => { saveItem(facilityOrderTemplateItems, index, e.target.value, isEnteral); }}
                                            disabled={disabled || disabledTable}
                                        />
                                }
                            </td>
                            <td className="is-flex">
                                {item.product && item.product.description} <span className="table__icons-wrapper"> {item.product && !item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.backordered != null ? item.backordered : item.product && item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span>
                            </td>
                            <td>
                                {item.product && item.product.unitOfMeasure ? item.product.unitOfMeasure.name : (item.product && item.product.uoM)}
                            </td>
                            <td className="table-col-input text-align-left">
                                <input
                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                    onClick={(e) => e.target.select()}
                                    onChange={(e) => {
                                        editItem(facilityOrderTemplateItems, index, e.target.value, isMasterPatient ? 'orderQuantity' : 'templateQuantity')
                                    }}
                                    value={isMasterPatient ? item.orderQuantity : item.templateQuantity}
                                    type="number"
                                    min="0"
                                    disabled={disabled || disabledTable}
                                />
                            </td>
                            <td>
                                {!isMasterPatient && isEnteral && isFormula ?
                                    <input
                                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                        onClick={() => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplateItems, index)}
                                        value={item.note}
                                        readOnly={true}
                                    /> :
                                    <input
                                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                        onClick={isFormula ? () => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplateItems, index) : (e) => e.target.select()}
                                        onChange={(e) => { item.note = e.target.value }}
                                        value={item.note}
                                        disabled={disabled || disabledTable}
                                        readOnly={isFormula}
                                    />
                                }
                            </td>
                            <td className="type--right">
                                <div className="table__icons">
                                    {
                                        item.product &&
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--delete--primary u-icon--sml"
                                            label="Delete"
                                            onlyIcon={true}
                                            onClick={() => deleteItem(facilityOrderTemplateItems, index)}
                                            disabled={disabled || disabledTable}
                                        ></BaasicButton>
                                    }
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
});

TemplateItemsTable.propTypes = {
    facilityOrderTemplateNewFlowCreateViewStore: PropTypes.object.isRequired,
    facilityOrderTemplateItems: PropTypes.object.isRequired,
    disabled: PropTypes.bool
};

FacilityOrderTemplateNewFlowCreateTemplate.propTypes = {
    facilityOrderTemplateNewFlowCreateViewStore: PropTypes.object.isRequired,
    disabled: PropTypes.bool
};

export default defaultTemplate(FacilityOrderTemplateNewFlowCreateTemplate);